<template>
  <div class="solution">
      <div>
        <!-- <component :is="HomeContent1"></component> -->
        <SolutionContent1/>
      </div>
  </div>
</template>

<script>
    import SolutionContent1 from '@/pages/solution-content/SolutionContent1.vue'
    export default {
      name: 'Solution',
      components:{SolutionContent1}
    }
</script>

<style>
  .solution{
	min-height: 23.3rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(../assets/img/solution-bg.jpg);
  }
</style>



// WEBPACK FOOTER //
// src/pages/Solution.vue